import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '@/stores/authStore';

import { authApi } from '../services/authApi';

import { authKeys } from './authKeys';

export function useSessionRevalidation() {
  const accessToken = useAuthStore((state) => state.accessToken);

  const query = useQuery({
    queryKey: authKeys.me(),
    queryFn: () => authApi.getMe(),
    enabled: Boolean(accessToken),
    retry: false,
  });

  // The store sync lives in an effect, NOT in queryFn. useOnboardingGate and
  // useClientKind observe this same key with their own (side-effect-free)
  // queryFn, and only one queryFn per key ever runs — whichever observer
  // registered it. Doing the sync off the resolved data instead means every
  // observer path lands the same result in the store, which is what carries
  // fields the persisted copy predates (ssoProvider, onboarded, clientType).
  const me = query.data?.status === 'success' ? query.data.data : undefined;
  useEffect(() => {
    if (me) useAuthStore.getState().setUser(me);
  }, [me]);

  return query;
}
